// Developer View as (2026-10-21): this browser tab shows the dashboard as one customer login sees it, read-only.
// The API keeps the real session (on the developer's own record, logged) and enforces read-only; this tab only
// remembers which login it shows and sends it on every request (x-view-as-uid). See apps/api/src/middleware/view-as.js.
import { showDemoNotice } from './demoNotice';

export const VIEW_AS_KEY = 'viewAsSession';
export const VIEW_AS_HEADER = 'x-view-as-uid';
const ID = /^[A-Za-z0-9_-]{1,128}$/;

export function viewAsSession() {
  try {
    const raw = sessionStorage.getItem(VIEW_AS_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (session && ID.test(session.uid || '') && Number(session.expiresAt) > Date.now()) return session;
    sessionStorage.removeItem(VIEW_AS_KEY);
  } catch { /* storage unavailable or damaged: not viewing as anyone */ }
  return null;
}

export const isViewingAs = () => viewAsSession() !== null;

export function viewAsHeaders() {
  const session = viewAsSession();
  return session ? { [VIEW_AS_HEADER]: session.uid } : {};
}

// Remembers the login this tab shows; everything that belonged to the developer's own view is dropped first.
export function rememberViewAs({ profile, expiresAt }) {
  for (const key of ['developerSelectedOrgId', 'supportSelectedOrgId', 'companySelectedWash', 'companyHomeChosen']) {
    sessionStorage.removeItem(key);
  }
  for (const key of ['selectedOrgId', 'selectedLocationId']) localStorage.removeItem(key);
  sessionStorage.setItem(VIEW_AS_KEY, JSON.stringify({
    uid: profile.uid, email: profile.email || '', name: profile.displayName || profile.name || profile.email || profile.uid,
    role: profile.role || '', expiresAt
  }));
}

export function forgetViewAs() {
  try {
    sessionStorage.removeItem(VIEW_AS_KEY);
    for (const key of ['companySelectedWash', 'companyHomeChosen']) sessionStorage.removeItem(key);
    for (const key of ['selectedOrgId', 'selectedLocationId']) localStorage.removeItem(key);
  } catch { /* nothing stored */ }
}

export const VIEW_AS_CODES = ['VIEW_AS_ENDED', 'VIEW_AS_DENIED'];

// A refused save while viewing (or while a session is on in another tab): one small notice, like the demo's.
export function showViewAsReadOnlyNotice(message) {
  showDemoNotice(message || 'View as is read-only. Nothing was changed.');
}
